import { useMemo } from 'react';
import { CoinsLabelWrapper } from './CoinsLabel.style';

export type CoinsLabelProps = {
  amount: number;
  valueLabel: string;
  valueLabelPlural?: string;
};

let __coinsSvgId = 0;
const nextCoinsId = () => {
	__coinsSvgId += 1;
	return `coins_${__coinsSvgId}`;
};

type CoinsSVGProps = {
  idSuffix: string;
};

const CoinsSVG = ({ idSuffix }: CoinsSVGProps) => {
	const filterId = `coins_filter_${idSuffix}`;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<circle cx="10.9475" cy="10" r="9" fill="#F5BB0A" />
			{/* eslint-disable-next-line max-len */}
			<path fillRule="evenodd" clipRule="evenodd" d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 16.6316C13.6625 16.6316 16.6316 13.6625 16.6316 10C16.6316 6.33748 13.6625 3.36842 10 3.36842C6.33748 3.36842 3.36842 6.33748 3.36842 10C3.36842 13.6625 6.33748 16.6316 10 16.6316Z" fill="#FFE251" />
			{/* eslint-disable-next-line max-len */}
			<path fillRule="evenodd" clipRule="evenodd" d="M3.38507 9.52632C3.62795 12.9678 6.49674 15.6842 9.99999 15.6842C13.5032 15.6842 16.372 12.9678 16.6149 9.52632C16.626 9.68278 16.6316 9.84074 16.6316 10C16.6316 13.6625 13.6625 16.6316 9.99999 16.6316C6.33747 16.6316 3.36841 13.6625 3.36841 10C3.36841 9.84074 3.37402 9.68278 3.38507 9.52632Z" fill="#F48D03" />
			{/* eslint-disable-next-line max-len */}
			<path fillRule="evenodd" clipRule="evenodd" d="M16.6149 9.52631C16.372 6.08487 13.5032 3.36843 9.99993 3.36843C6.49668 3.36843 3.62789 6.08487 3.38501 9.52631C3.62789 12.9678 6.49668 15.6842 9.99993 15.6842C13.5032 15.6842 16.372 12.9678 16.6149 9.52631Z" fill="#FEBD01" />
			{/* eslint-disable-next-line max-len */}
			<path fillRule="evenodd" clipRule="evenodd" d="M14.4464 5.07988C15.6788 6.19437 16.4906 7.76544 16.6148 9.52632C16.3719 12.9678 13.5032 15.6842 9.9999 15.6842C8.28916 15.6842 6.72971 15.0364 5.55347 13.9728L14.4464 5.07988Z" fill="#FAA201" />

			<g filter={`url(#${filterId})`}>
				{/* eslint-disable-next-line max-len */}
				<path d="M10.7994 11.3979H8.60338V10.133H10.7994C11.1585 10.133 11.4494 10.0745 11.6719 9.95736C11.8983 9.83633 12.0643 9.67236 12.1697 9.46545C12.2751 9.25464 12.3278 9.01454 12.3278 8.74517C12.3278 8.4836 12.2751 8.2396 12.1697 8.01317C12.0643 7.78674 11.8983 7.60325 11.6719 7.4627C11.4494 7.32216 11.1585 7.25189 10.7994 7.25189H9.13042V14.5075H7.52002V5.98114H10.7994C11.4631 5.98114 12.0291 6.10021 12.4976 6.33836C12.97 6.57259 13.3292 6.89858 13.5751 7.31631C13.825 7.73013 13.9499 8.20251 13.9499 8.73345C13.9499 9.28392 13.825 9.75825 13.5751 10.1565C13.3292 10.5547 12.97 10.8611 12.4976 11.0758C12.0291 11.2906 11.4631 11.3979 10.7994 11.3979Z" fill="#FFEB98" />
			</g>

			<defs>
				{/* eslint-disable-next-line max-len */}
				<filter
					id={filterId}
					x="7.52002"
					y="5.98114"
					width="7.42993"
					height="8.52631"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					{/* eslint-disable-next-line max-len */}
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					{/* eslint-disable-next-line max-len */}
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
					<feOffset dx="1" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};

export const CoinsLabel = ({
	amount,
	valueLabel,
	valueLabelPlural = `${valueLabel}s`,
}: CoinsLabelProps) => {
	const idSuffix = useMemo(() => nextCoinsId(), []);

	return (
		<CoinsLabelWrapper>
			<CoinsSVG idSuffix={idSuffix} />
			<span>
				{amount} {amount === 1 ? valueLabel : valueLabelPlural}
			</span>
		</CoinsLabelWrapper>
	);
};
